import styled from 'styled-components';

const SlideHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(6)};
  padding: ${({ theme }) => `${theme.spacing(2)} 0`};
  color: ${({ theme }) => theme.colors.white};
  width: fit-content;

  ${({ theme: { media } }) => `${media.medium(
    () => `
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    `,
  )}
  `};
`;

export default SlideHeader;
